import React from 'react';
import { Flex, Text, Icon } from '@spothero/ui';
import IconFlameFilled from '@spothero/icons/flame-filled';
import { shouldShowPriceUrgencyCallout } from './utils';
const PriceUrgencyCallout = ({ tieredAvailability, availability, isShowSpotsLeftVisible = false, }) => {
    if (!shouldShowPriceUrgencyCallout(tieredAvailability, availability, isShowSpotsLeftVisible)) {
        return null;
    }
    const { currentTierInventoryRemaining } = tieredAvailability;
    return (<Flex align="center" gap="1" justifyContent="flex-end" minWidth="75px" mb="1" color="red.default">
            <Icon as={IconFlameFilled} boxSize="4" width="4" height="4"/>
            <Text fontSize="sm" fontWeight="semibold">
                {currentTierInventoryRemaining} left at
            </Text>
        </Flex>);
};
export default PriceUrgencyCallout;
